<template>
  <div class="card-block rs-scroll rs-scroll--x bg-white">
    <div class="form-group row">
      <label for="estimate_methodology" class="col-sm-3 col-form-label">Estimate Methodology</label>
      <div class="col-sm-9">
        <multiselect
            id="estimate_methodology"
            v-model="computedEstimateMethodology"
            :options="computedEstimateMethodologies"
            :showLabels="false"
            :option-height="29"
            :max-height="203"
            open-direction="bottom"
            :close-on-select="true"
            placeholder="Select State"
            :disabled="!isStatusActive || isBlockByAuda"
            style="opacity: 1"
            track-by="key"
            label="value"
            @input="selectedEstimateMethodology"
        >
        </multiselect>
      </div>
    </div>

    <div class="form-group row">
      <label for="rr" class="col-sm-3 col-form-label">RR</label>
      <div class="col-sm-9">
        <input v-if="isEstimateMethodologyDollars" :value="'$0.00'" class="form-control" readonly />
        <number-formatter
            v-else
            ref="rr"
            v-model="estimateRates.rr"
            type="text"
            class="form-control"
            id="rr"
            placeholder="RR Amount"
            format="$0,0.00"
            :disabled="estimateRates.insurer_rate_id === 0 || !isStatusActive || isBlockByAuda || isDisabledRates || isDisabledRatesRR"
            @onChange="autoUpdateRates({estimateRates: {rr: estimateRates.rr}})"></number-formatter>
      </div>
    </div>

    <div class="form-group row">
      <label for="repair" class="col-sm-3 col-form-label">Repair</label>
      <div class="col-sm-9">
        <input v-if="isEstimateMethodologyDollars" :value="'$0.00'" class="form-control" readonly />
        <number-formatter
            v-else
            ref="repair"
            type="text"
            v-model="estimateRates.repair"
            class="form-control"
            id="repair"
            placeholder="Repair"
            format="$0,0.00"
            :disabled="estimateRates.insurer_rate_id === 0 || !isStatusActive ||isBlockByAuda|| isDisabledRates || isDisabledRatesRepair"
            @onChange="autoUpdateRates({estimateRates: {repair: estimateRates.repair}})"></number-formatter>
      </div>
    </div>

    <div class="form-group row">
      <label for="paint" class="col-sm-3 col-form-label">Paint</label>
      <div class="col-sm-9">
        <template v-if="isShowPaintRateForCustomMethodology">
          <span v-if="estimateRates.paint == 0 || estimateRates.paint=='0.00'" class="form-control close-edit-cursor">
            $0.00 - {{ estimateRates.paint_material != 'not_set' ? estimateRates.paint_material : '' }} RATE NOT SET
          </span>
          <span v-else class="form-control close-edit-cursor">${{ estimateRates.paint }} - SET BY PAINT MATERIAL</span>
        </template>
        <template v-else>
          <input v-if="isEstimateMethodologyDollars" :value="'$0.00'" class="form-control" readonly />
          <number-formatter
              v-else
              ref="paint"
              type="text"
              v-model="estimateRates.paint"
              class="form-control"
              id="paint"
              placeholder="Paint"
              format="$0,0.00"
              :disabled="estimateRates.insurer_rate_id === 0 || !isStatusActive ||isBlockByAuda|| isDisabledRates || isDisabledRatesPaint"
              @onChange="autoUpdateRates({estimateRates: {paint: estimateRates.paint}})"/>
        </template>
      </div>
    </div>

    <div class="form-group row">
      <label for="paint_material" class="col-sm-3 col-form-label">Paint Material</label>
      <div class="col-sm-9">
        <multiselect
            class="rates-paint-material"
            ref="RatesPaintMaterial"
            id="paint_material"
            v-model="estimateRates.paint_material"
            :options="paintMaterials.map(data => data.key)"
            :custom-label="opt => paintMaterials.find(x => x.key == opt).value"
            :showLabels="false"
            :option-height="29"
            :max-height="203"
            :close-on-select="true"
            :disabled="!isStatusActive || isBlockByAuda"
            style="opacity: 1"
            @select="autoUpdateRates({estimateRates: {paint_material: estimateRates.paint_material}})"
            @input="selectedPaintMaterial"
            :class="{ 'show-red-border-for-paint-material': isShowRedBorderForPaintMaterial }"
        >
        </multiselect>
        <small v-if="isShowRedBorderForPaintMaterial" class="form-text show-help-for-paint-material">
          Please select a value to be saved.
        </small>
        <small v-if="isShowRedBorderIfNewPaintColour" class="form-text show-help-for-paint-material">
          You have created a new Paint Colour. Please set a default paint material code.
        </small>
      </div>
    </div>

    <div class="form-group row">
      <label for="partmarkup" class="col-sm-3 col-form-label">Part Markup</label>
      <div class="col-sm-9">
        <number-formatter ref="partmarkup" type="text" v-model="estimateRates.partmarkup"
                          class="form-control" id="partmarkup"
                          placeholder="Part Markup"
                          format="0.00%"
                          :percentage="true"
                          :is-disabled="!isStatusActive || isBlockByAuda"
                          @onChange="autoUpdateRates({estimateRates: {partmarkup: estimateRates.partmarkup}})"></number-formatter>
      </div>
    </div>

    <div class="form-group row">
      <label for="mechanical" class="col-sm-3 col-form-label">Mechanical</label>
      <div class="col-sm-9">
        <input v-if="isEstimateMethodologyDollars" :value="'$0.00'" class="form-control" readonly />
        <number-formatter v-else type="text"
                          class="form-control" id="mechanical"
                          placeholder="Mechanical"
                          format="$0,0.00"
                          :is-disabled="!isStatusActive ||isBlockByAuda"
                          v-model="estimateRates.mechanical"
                          @onChange="autoUpdateRates({estimateRates: {mechanical: estimateRates.mechanical}})"></number-formatter>
      </div>
    </div>
  </div>
</template>
<script>
import NumberFormatter from '../../utility/number-formatter'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import {mapGetters  } from 'vuex'

export default {
  name: 'estimate-rates',
  components: {
    NumberFormatter,
    Multiselect,
  },
  props: {
    estimateRates: { type: Object, required: true },
    defaultValues: { type: Object, required: true },
    card: { type: Object, required: true },
    properties: { type: Object, required: true },
    isShowPaintMaterialNotification: { type: Boolean, default: false },
    isShowNewPaintColourNotification: { type: Boolean, default: false },
    isInsuranceRepairYes: { type: Boolean, default: false },
    aiEstimateType:{type:[String,null],default:null}
  },
  data() {
    return {
      backdoor: 0,
      callRatesUpdate: 0,
      paintMaterials: [
        { key: 'not_set', value: '' },
        { key: 'S1', value: 'S1' },
        { key: 'S2', value: 'S2' },
        { key: 'M1', value: 'M1' },
        { key: 'M2', value: 'M2' },
        { key: 'M3', value: 'M3' },
        { key: 'M3PLUS', value: 'M3+' },
      ],
      estimateMethodologies: [
        { key: 'custom', value: 'Custom' },
        { key: 'ntar', value: 'NTAR' },
        { key: 'ltar', value: 'LTAR' },
        { key: 'zi', value: 'Zurich' },
        { key: 'dollars', value: 'Dollars' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      isStatusActive: 'isStatusActive',
      isRsEnabled: 'isRsEnabled',
    }),
    isEstimateMethodologyDollars() {
      this.callRatesUpdate++
      return this.estimateRates.estimate_methodology == 'dollars'
    },
    isDisabledRates() {
      return (this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesEditable === false
    },
    isDisabledRatesRR() {
      return ((this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesRREditable === false)
    },
    isDisabledRatesRepair() {
      return (this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesRepairEditable === false
    },
    isDisabledRatesPaint() {
      return (this.properties.isFromIag || this.properties.isFromEio || this.properties.isFromAudaBridge || this.properties.isFromAudaNet) && this.properties.isRatesPaintEditable === false
    },
    computedEstimateMethodologies() {
      let em = this.estimateMethodologies.slice()
      if (this.isRsEnabled) {
        em.push({ key: 'rs', value: 'RS' })
      }

      em.forEach((item) => {
         item.$isDisabled = false
        if (this.aiEstimateType === 'quick-2' && item.key === 'dollars') {
          item.$isDisabled = true
        }
        if (this.aiEstimateType === 'quick-1' && item.key !== 'dollars') {
          item.$isDisabled = true
        }
      })
      console.log('computedEstimateMethodologies', em)
      return em
    },
    computedEstimateMethodology: {
      get: function () {
        this.backdoor
        // const aiOverrides = {
        //   'quick-1': { key: 'dollars', value: 'Dollars' },
        //   'quick-2': { key: 'custom', value: 'Custom' },
        // }
        // if (aiOverrides[this.aiEstimateType]) {
        //   const overrideKey = aiOverrides[this.aiEstimateType].key
        //   if (this.estimateRates.estimate_methodology !== overrideKey) {
        //     this.estimateRates.estimate_methodology = overrideKey
        //   }
        //   const override = _.find(this.computedEstimateMethodologies, (itm) => {
        //     return itm.key === overrideKey
        //   })
        //   return override || aiOverrides[this.aiEstimateType]
        // }
        let vm = this
        try {
          let item = _.find(this.computedEstimateMethodologies, function (itm) {
            return itm.key.toLowerCase() === vm.estimateRates.estimate_methodology.toLowerCase()
          })
          return item
        } catch (e) {
          return { key: 'custom', value: 'Custom' }
        }
      },
      set: function (item) {
        this.estimateRates.estimate_methodology = item.key
        this.backdoor++
      },
    },
    isShowPaintRateForCustomMethodology: function () {
      return !!(this.isEstimateMethodologyCustom && this.isInsuranceRepairYes)
    },
    isEstimateMethodologyCustom: function () {
      this.backdoor
      if (this.estimateRates.estimate_methodology == 'custom') {
        return true
      }
      return false
    },
    isShowRedBorderForPaintMaterial: function () {
      return (this.isShowPaintMaterialNotification && !this.isShowRedBorderIfNewPaintColour && !this.isEstimateMethodologyCustom && this.estimateRates.paint_material === 'not_set')
    },
    isShowRedBorderIfNewPaintColour: function () {
      return (this.isShowNewPaintColourNotification)
    },
    isBlockByAuda() {
      return (this.properties?.isBlockByAuda === true)
    },
  },
  methods: {
    autoUpdateRates: function (data = false) {
      this.callRatesUpdate++
      let update = {}
      if (!data) {
        update.estimateRates = this.estimateRates
      } else {
        update = data
      }
      this.$emit('autoUpdateRates', update)
    },
    selectedEstimateMethodology() {
      let type = this.estimateRates.estimate_methodology
      let estimateRatesCopy = _.cloneDeep(this.estimateRates)
      if (!this.isDisabledRates) {
        this.$set(this.estimateRates, 'rr', this.card?.insurance?.rates?.estimate_rates_rr || _.cloneDeep(this.defaultValues.rates[type].default_rates_rr))
        this.$set(this.estimateRates, 'repair', this.card?.insurance?.rates?.estimate_rates_repair || _.cloneDeep(this.defaultValues.rates[type].default_rates_repair))
        this.$set(this.estimateRates, 'paint', this.card?.insurance?.rates?.estimate_rates_paint || _.cloneDeep(this.defaultValues.rates[type].default_rates_paint))
        this.$set(this.estimateRates, 'mechanical', _.cloneDeep(this.defaultValues?.rates[type]?.default_rates_mechanical))
      } else {
        if (!this.isDisabledRatesRR) {
          this.$set(this.estimateRates, 'rr', this.card?.insurance?.rates?.estimate_rates_rr || _.cloneDeep(this.defaultValues.rates[type].default_rates_rr))
        }
        if (!this.isDisabledRatesRepair) {
          this.$set(this.estimateRates, 'repair', this.card?.insurance?.rates?.estimate_rates_repair || _.cloneDeep(this.defaultValues.rates[type].default_rates_repair))
        }
        if (!this.isDisabledRatesPaint) {
          this.$set(this.estimateRates, 'paint', this.card?.insurance?.rates?.estimate_rates_paint || _.cloneDeep(this.defaultValues.rates[type].default_rates_paint))
        }
      }

      if (type == 'ltar' || type == 'ntar' || type == 'zi') {
        this.$set(this.estimateRates, 'paint_material', _.cloneDeep(this.defaultValues.rates[type].default_rates_paint_material))
      }

      if (type == 'dollars') {
        this.$set(this.estimateRates, 'paint_material', 'S1')
      }

      if (type == 'custom' && this.estimateRates.paint_material && this.card.insurance.rates?.estimate_methodology == 'custom' && this.card.insurance.custom_paint_times[this.estimateRates.paint_material.toLowerCase()]) {
        this.$set(this.estimateRates, 'paint', _.cloneDeep(this.card.insurance.custom_paint_times[this.estimateRates.paint_material.toLowerCase()]))
      }

      let data = {
        estimateRates: {
          estimate_methodology: type
        }
      }
      if (Number(estimateRatesCopy.rr) !== Number(this.estimateRates.rr) && type !== 'dollars') {
        data.estimateRates.rr = this.estimateRates.rr
      }

      if (Number(estimateRatesCopy.repair) !== Number(this.estimateRates.repair) && type !== 'dollars') {
        data.estimateRates.repair = this.estimateRates.repair
      }

      if (Number(estimateRatesCopy.paint) !== Number(this.estimateRates.paint) && type !== 'dollars') {
        data.estimateRates.paint = this.estimateRates.paint
      }

      if (Number(estimateRatesCopy.mechanical) !== Number(this.estimateRates.mechanical)) {
        data.estimateRates.mechanical = this.estimateRates.mechanical
      }

      if (estimateRatesCopy.paint_material !== this.estimateRates.paint_material) {
        data.estimateRates.paint_material = this.estimateRates.paint_material
      }
      this.autoUpdateRates(data)
      this.$emit('loadTimesForItemPart')
    },
    selectedPaintMaterial() {
      this.backdoor
      if (this.isEstimateMethodologyCustom && this.isInsuranceRepairYes) {
        if (this.estimateRates.paint_material == 'not_set' || !(this.estimateRates.paint_material)) {
          this.estimateRates.paint = 0
        } else {
          this.estimateRates.paint = this.card.insurance.custom_paint_times[this.estimateRates.paint_material.toLowerCase()] || 0
        }
      }
      this.backdoor++
    },
  },
}
</script>
<style>
.multiselect__option--disabled {
  opacity: 0.6;
  cursor: not-allowed;
}</style>
<style scoped>
.card-block {
  padding: 15px;
}

.form-group {
  margin-bottom: 15px;
}

.show-red-border-for-paint-material {
  border-color: #dc3545 !important;
}

.show-help-for-paint-material {
  color: #dc3545;
  display: block;
  margin-top: 5px;
}

.close-edit-cursor {
  cursor: not-allowed;
  background-color: #e9ecef;
}
</style>
